module.exports = __webpack_public_path__ + "img/portfolio-02-481x325.5d75f1df.jpg";